module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?d95c91e88cc28d3305af7a00309290d6";